import FingerprintJS from '@fingerprintjs/fingerprintjs';

let cachedVendorId = null;

export async function getVendorId() {
    if (cachedVendorId) return cachedVendorId;

    const fp = await FingerprintJS.load();
    const result = await fp.get();
    cachedVendorId = result.visitorId;

    return cachedVendorId;
} 